import { render, staticRenderFns } from "./updateFlightDialog.vue?vue&type=template&id=fb2e8be2&"
import script from "./updateFlightDialog.vue?vue&type=script&lang=js&"
export * from "./updateFlightDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2e8be2')) {
      api.createRecord('fb2e8be2', component.options)
    } else {
      api.reload('fb2e8be2', component.options)
    }
    module.hot.accept("./updateFlightDialog.vue?vue&type=template&id=fb2e8be2&", function () {
      api.rerender('fb2e8be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/routeCentral/updateFlightDialog.vue"
export default component.exports